"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trainingImportReportSchema = exports.trainingImportDevirOzetiSchema = exports.trainingImportPreviewSchema = exports.trainingDevirKonuEslemesiSchema = exports.egitimIceAktarmaKipiSchema = exports.EGITIM_ICE_AKTARMA_KIPLERI = exports.EGITIM_ICE_AKTARMA_SONUC_ETIKETI = exports.egitimIceAktarmaSonucSchema = exports.EGITIM_ICE_AKTARMA_SONUCLARI = exports.trainingListSchema = exports.EGITIM_SAYFA_BOYUTU = exports.BOS_EGITIM_SUZGECI = exports.publicDegerlendirmeSonucSchema = exports.publicDegerlendirmeCreateSchema = exports.publicDegerlendirmeOptionsSchema = exports.trainingOptionsSchema = exports.trainingDetailSchema = exports.trainingSummarySchema = exports.yetkinlikVadeDurumuSchema = exports.YETKINLIK_VADE_DURUMLARI = exports.trainingQrSonucSchema = exports.trainingKonuSchema = exports.trainingParticipantSonucSchema = exports.trainingParticipantAddSchema = exports.trainingUpdateSchema = exports.trainingCreateSchema = exports.trainingKatilimciInputSchema = exports.EGITIM_YETKI_VARSAYILAN = exports.EGITIM_YETKI_ANAHTARI = exports.dersSaatiKuraliSchema = exports.tehlikeSinifiHaritasiSchema = exports.SINAV_BARAJI_VARSAYILAN = exports.SINAV_DENEME_MAX = exports.sureSinifiSchema = exports.SURE_SINIFLARI = exports.EGITIM_SONUC_ETIKETI = exports.EGITIM_TARAF_ETIKETI = exports.EGITIM_YONTEM_ETIKETI = exports.egitimSonucuSchema = exports.EGITIM_SONUCLARI = exports.egitimTarafiSchema = exports.EGITIM_TARAFLARI = exports.egitimYontemiSchema = exports.EGITIM_YONTEMLERI = void 0;
exports.tehlikeSinifiAnahtari = tehlikeSinifiAnahtari;
exports.readGecerlilikAy = readGecerlilikAy;
exports.readSureSinifi = readSureSinifi;
exports.readYetkinlikUretir = readYetkinlikUretir;
exports.readGrupBasligi = readGrupBasligi;
exports.readSinavBaraji = readSinavBaraji;
exports.readDersSaati = readDersSaati;
exports.readGrup = readGrup;
exports.sureSinifiIhlalleri = sureSinifiIhlalleri;
exports.sureSinifiUyarilari = sureSinifiUyarilari;
exports.deriveYetkinlikBitis = deriveYetkinlikBitis;
exports.sinavSonucOnerisi = sinavSonucOnerisi;
exports.egitimBastanAlinmaliMi = egitimBastanAlinmaliMi;
exports.egitimKisiSaat = egitimKisiSaat;
exports.dersSaatiUyarilari = dersSaatiUyarilari;
exports.egitimYetkiListesiIhlali = egitimYetkiListesiIhlali;
exports.yetkinlikVadeDurumu = yetkinlikVadeDurumu;
exports.yetkinlikBugunGecerliMi = yetkinlikBugunGecerliMi;
exports.onKosulIstihdamSonrasiMi = onKosulIstihdamSonrasiMi;
exports.egitimSuzgecSorgusu = egitimSuzgecSorgusu;
exports.etkinEgitimSuzgeciSayisi = etkinEgitimSuzgeciSayisi;
exports.egitimIceAktarmaKipiCoz = egitimIceAktarmaKipiCoz;
const zod_1 = require("zod");
const shared_types_1 = require("@isg/shared-types");
const incident_1 = require("./incident");
const kapi_durumu_1 = require("./kapi-durumu");
/**
 * Eğitim modülü — üç katmanın paylaştığı sabitler ve kural okuyucuları
 * (F3B·S6; Kapsam §16.10 + §19/11-7·8 + §19/12-g·h·i, ERD §10b).
 *
 * PTW/olay deseninin eğitim kolu: enum token'ları, süre modeli ve sözlük
 * kural eksenleri BURADA tek kaynaktır — `@isg/db egitim.ts` bunları okur,
 * ikinci bir tablo/okuyucu yazılmaz.
 */
// ── Enum token'ları (ekran etiketleri i18n'den; enum'a Türkçe girmez) ────────
/** Eğitimin veriliş biçimi (T1). İBYS ayrı alan ister.
 *  ⚠️ YÖNTEM KISITI KURALI YOK (madde 67): "ilk temel eğitim uzaktan
 *  verilemez" bilgisi mevzuat metni görülmeden kabul edilmedi (Yönerge §5);
 *  alan hazır, kural metin gelince bağlanır — şema borcu yok. */
exports.EGITIM_YONTEMLERI = ['yuz_yuze', 'online', 'karma'];
exports.egitimYontemiSchema = zod_1.z.enum(exports.EGITIM_YONTEMLERI);
/** Katılımcı tarafı (T2) — olay modülündeki etkilenen kişi taraf ekseninin
 *  ikizi. **Ziyaretçi YOK:** kayıtsız dış katılımcı eğitim modülünden
 *  reddedildi (yetkinlik üretmez, süre taşımaz, İBYS'ye gitmez, kişi×saate
 *  girmez — session-log madde 66). */
exports.EGITIM_TARAFLARI = ['ana_firma', 'yuklenici'];
exports.egitimTarafiSchema = zod_1.z.enum(exports.EGITIM_TARAFLARI);
/** Katılımcı sonucu (T3). Varsayılan `basarili` — uzman yalnız istisnayı
 *  işaretler; **yetkinlik YALNIZ `basarili`de doğar** ("katıldı" ≠ "yeterli"). */
exports.EGITIM_SONUCLARI = ['basarili', 'basarisiz', 'katilmadi'];
exports.egitimSonucuSchema = zod_1.z.enum(exports.EGITIM_SONUCLARI);
/**
 * Tur 5 / Y3 — ETİKETLER ÜÇ KATMANIN ORTAK KALEMİ: ekran ile SUNUCUDA üretilen
 * PDF aynı kelimeyi kullansın (S9 dersi — `RISK_SEVIYESI_ETIKETI` deseni).
 * Web `i18n/tr.ts` bunları yeniden yazmaz, aynalar.
 */
exports.EGITIM_YONTEM_ETIKETI = {
    yuz_yuze: 'Yüz yüze',
    online: 'Online',
    karma: 'Karma',
};
exports.EGITIM_TARAF_ETIKETI = {
    ana_firma: 'Ana firma',
    yuklenici: 'Yüklenici',
};
exports.EGITIM_SONUC_ETIKETI = {
    basarili: 'Başarılı',
    basarisiz: 'Başarısız',
    katilmadi: 'Katılmadı',
};
/**
 * SÜRE SINIFI — üç etiket (Kapsam §19/11-7, içerik turu E5). Bu ayrım
 * karıştırılırsa **sessiz uygunluk hatası** doğar: sistem yanlış bitiş
 * hesaplar ve belgeyi "geçerli" der.
 *   kural    sistem HESAPLAR — eğitim tarihi + `gecerlilik_ay`[tehlike sınıfı]
 *   belge    sistem HESAPLAMAZ — bitiş belgeden okunur, KAYITTA girilir
 *            (kişiye özel: aynı belge iki kişide farklı tarihte biter)
 *   suresiz  bitiş yok; tekrar gerekiyorsa OLAY tetikler (yeni istihdam vb.)
 */
exports.SURE_SINIFLARI = ['kural', 'belge', 'suresiz'];
exports.sureSinifiSchema = zod_1.z.enum(exports.SURE_SINIFLARI);
/** Sınav tekrar hakkı tavanı (18.08.2026 mevzuat eki): üçüncü denemede de
 *  başarısızsa "eğitim baştan alınmalı" UYARISI doğar — ENGEL DEĞİL.
 *  Önceki denemelerin puan geçmişi TUTULMAZ (bilinçli). */
exports.SINAV_DENEME_MAX = 3;
/** Temel İSG sınav barajı — kütüphane VARSAYILANI (tenant değiştirebilir).
 *  ✏️ T3 revizyonu: eşik VARDIR ama **sonucu OTOMATİK YAZMAZ** — sistem
 *  ÖNERİR, uzman işaretler. */
exports.SINAV_BARAJI_VARSAYILAN = 60;
// ── Sözlük kural ekseni okuyucuları (readUyariEsigiGun deseni) ───────────────
//
// Ortak sözleşme: bozuk/eksik değer OKUMAYI DÜŞÜRMEZ — kalem o kural
// bakımından "tanımsız" sayılır. Eksen listesi §19/11 gereği sonradan
// DEĞİŞTİRİLEMEZ; buraya yeni anahtar eklemek ÜRÜN kararıdır.
function kuralNesnesi(kurallar) {
    if (typeof kurallar !== 'object' || kurallar === null || Array.isArray(kurallar))
        return null;
    return kurallar;
}
/** Tehlike sınıfı ekseni — TEK BİÇİM (§19/11-1): üçü de yazılır, değişmeyen
 *  kalemde üç değer aynıdır. İki biçim (düz sayı VEYA harita) olsaydı kuralı
 *  okuyan her yerde dallanma olurdu. */
exports.tehlikeSinifiHaritasiSchema = zod_1.z.object({
    az: zod_1.z.number().int().positive(),
    tehlikeli: zod_1.z.number().int().positive(),
    cok: zod_1.z.number().int().positive(),
});
/** Tehlike sınıfı enum'undan harita anahtarına — TEK çeviri noktası. */
function tehlikeSinifiAnahtari(sinif) {
    return sinif === 'low_risk' ? 'az' : sinif === 'hazardous' ? 'tehlikeli' : 'cok';
}
/** `gecerlilik_ay: {az, tehlikeli, cok}` — periyot, birim AY (`+n month`;
 *  artık yıl kayması yok). `belge` ve `suresiz` sınıflı kalemde BULUNMAZ. */
function readGecerlilikAy(kurallar) {
    const nesne = kuralNesnesi(kurallar);
    if (!nesne)
        return null;
    const parsed = exports.tehlikeSinifiHaritasiSchema.safeParse(nesne['gecerlilik_ay']);
    return parsed.success ? parsed.data : null;
}
/** `sure_sinifi` — tanımsızsa null (kalem süre modeline katılmaz). */
function readSureSinifi(kurallar) {
    const nesne = kuralNesnesi(kurallar);
    if (!nesne)
        return null;
    const parsed = exports.sureSinifiSchema.safeParse(nesne['sure_sinifi']);
    return parsed.success ? parsed.data : null;
}
/** `yetkinlik_uretir: true` — eğitim başarıyla tamamlanınca kişi dosyasına
 *  yetkinlik yazılır (T5). Varsayılan HAYIR: işaret yoksa yetkinlik doğmaz. */
function readYetkinlikUretir(kurallar) {
    return kuralNesnesi(kurallar)?.['yetkinlik_uretir'] === true;
}
/** `grup_basligi: true` — ŞEMSİYE KALEM (ör. "Mesleki/teknik eğitimler"):
 *  rapor başlığıdır, **eğitim kaydı ALAMAZ** (C.1 — *"hepsine mesleki eğitim
 *  deyip geçemeyiz"*). Servis bunu 422 ile reddeder. */
function readGrupBasligi(kurallar) {
    return kuralNesnesi(kurallar)?.['grup_basligi'] === true;
}
/** `sinav_baraji` — 0-100 arası puan eşiği; yoksa null (sınav önerisi
 *  üretilmez). */
function readSinavBaraji(kurallar) {
    const deger = kuralNesnesi(kurallar)?.['sinav_baraji'];
    const parsed = zod_1.z.number().min(0).max(100).safeParse(deger);
    return parsed.success ? parsed.data : null;
}
/**
 * `ders_saati: { ilk: {az,tehlikeli,cok}, tekrar: {...}, dorduncu_grup: {...} }`
 * — 18.08.2026 mevzuat eki (md. 13/1 + 14/2 + 13/3). **BİRİM DERS SAATİ**,
 * saate çevrilmez (mevzuat dili korunur; dönüşüm varsayımı uydurmak olurdu).
 * Eksik süre UYARI üretir, kaydı ENGELLEMEZ.
 */
exports.dersSaatiKuraliSchema = zod_1.z.object({
    ilk: exports.tehlikeSinifiHaritasiSchema,
    tekrar: exports.tehlikeSinifiHaritasiSchema,
    dorduncu_grup: exports.tehlikeSinifiHaritasiSchema,
});
function readDersSaati(kurallar) {
    const nesne = kuralNesnesi(kurallar);
    if (!nesne)
        return null;
    const parsed = exports.dersSaatiKuraliSchema.safeParse(nesne['ders_saati']);
    return parsed.success ? parsed.data : null;
}
// ⚠️ **`readIsyeriOran` SÖKÜLDÜ (TUR 8 / A1).** `isyeri_oran` yetkinlik
// ekseninde ikinci bir 20/15/10 taşıyordu; bölen artık **yükümlülük
// kütüphanesinde tek yerde** yaşar ve görevlendirme kütüphanesi onu
// TÜRETİR (A5 — `zorunluSayiKutuphaneden`). Tek okuyucusu olan
// `isyeriIlkYardimciOrani` de aynı turda söküldü; kuralı okuyan kalmadığı
// için kural da kalmadı (*"kural var, çağıran yok"* — Yönerge §6/9-d).
/** `grup` — sözlük kaleminin grup etiketi (kök sebep deseni): `egitim_turu`da
 *  `mesleki`, `egitim_konusu`nda `genel`/`saglik`/`teknik`/`isyerine_ozel`. */
function readGrup(kurallar) {
    const deger = kuralNesnesi(kurallar)?.['grup'];
    return typeof deger === 'string' && deger.length > 0 ? deger : null;
}
// ── GUARD: süre sınıfı tutarlılığı (E bölümünün kilidi) ──────────────────────
/**
 * **`belge` sınıflı kalem periyot alanı TAŞIYAMAZ.** MYK belgesine periyot
 * yazılırsa sistem `son_kontrol + periyot` mantığıyla bir bitiş HESAPLAR ve
 * belgeyi "geçerli" sayar — oysa gerçek bitiş belgenin üstündedir ve kişiye
 * özeldir. Sonuç: **sessiz uygunluk hatası** — ölçtüğünü sandığı şeyi
 * ölçmeyen gösterge (Teknoloji §9); hiç göstermeyenden tehlikelidir.
 * `suresiz` kalemde de periyot anlamsızdır (bitiş yok).
 *
 * Dönüş: ihlal mesajları (boş dizi = kural tamam). Ret **422** — kural
 * ihlali, yetki sorunu değil.
 */
function sureSinifiIhlalleri(kurallar) {
    const sinif = readSureSinifi(kurallar);
    if (sinif === null)
        return [];
    const nesne = kuralNesnesi(kurallar);
    const periyotVar = nesne !== null && nesne['gecerlilik_ay'] !== undefined;
    if (sinif !== 'kural' && periyotVar) {
        // ⚠️ D2 (K13 — tur 5): iç ad ('belge' · `gecerlilik_ay`) kullanıcı
        // metnine inmez; kullanıcı NE YAPACAĞINI duyar.
        return [
            sinif === 'belge'
                ? 'Bu kalemin süresi belgenin üstünde yazar ve her kişi için kayıtta girilir — ' +
                    'yenileme periyodu tanımlanamaz. Periyot girmek istiyorsanız kalemin süre türünü ' +
                    '"sistem hesaplar" olarak değiştirin.'
                : 'Bu kalem süresiz tanımlı — yenileme periyodu girilemez. Periyot girmek istiyorsanız ' +
                    'kalemin süre türünü "sistem hesaplar" olarak değiştirin.',
        ];
    }
    return [];
}
/**
 * ✏️ REVİZE 18.08.2026 (Kapsam §19/11-7 + §16.10/15-B; ürün sahibi: c).
 * ~~`kural` sınıflı kalem periyot İSTER (422)~~ → **periyot tanımlanmamışsa
 * yetkinlik GEÇERLİ sayılır ve bu UYARI düşer.**
 *
 * Neden yön değişti: kütüphane mesleki kalemlerin periyodunu BİLMİYOR (çoğu
 * mevzuat değil şirket politikası) ve uydurmak Yönerge §5'e aykırı. Eski
 * guard o kalemleri `suresiz` yazmaya zorluyordu ve *"5 yıl önce alınmış
 * yüksekte çalışma eğitimi"* izin kapısında **süresiz geçerli** görünüyordu.
 *
 * ⚠️ **SES KISILMADI:** fail-loud ret UYARIYA dönüştü — sessiz geçiş DEĞİL.
 * Uyarı kaydın uyarı listesinde görünür (`sessionUyarilariTx`). Bunu "gereksiz
 * gürültü" diye kaldırma: periyodu olmayan `kural` kalemi, vadesi hiç dolmayan
 * bir yetkinlik üretir.
 */
function sureSinifiUyarilari(kurallar) {
    if (readSureSinifi(kurallar) !== 'kural')
        return [];
    if (readGecerlilikAy(kurallar) !== null)
        return [];
    // ⚠️ K13 (tur 5): metin YOLU tarif eder, JSON anahtarını değil — yol
    // Sözlükler → Eğitim türleri sekmesidir (İ2/K13 ile açıldı).
    return [
        'Bu eğitim türünde yenileme periyodu tanımlanmamış — doğan yetkinlik ' +
            'süresiz geçerli sayılır. Periyodu Sözlükler → Eğitim türleri ekranından girin.',
    ];
}
// ── Türetmeler ───────────────────────────────────────────────────────────────
/** Tarih aritmetiği UTC gün ekseninde (`deriveSonrakiKontrol` ile aynı eksen);
 *  ay ekleme `+n month` — artık yıl kayması yok. */
function ayEkle(tarih, ay) {
    const gun = new Date(Date.UTC(tarih.getUTCFullYear(), tarih.getUTCMonth(), tarih.getUTCDate(), 0, 0, 0, 0));
    const hedefGun = gun.getUTCDate();
    gun.setUTCMonth(gun.getUTCMonth() + ay);
    // Ay sonu taşması (31 Ocak + 1 ay): ayın son gününe çek, sonraki aya taşma.
    if (gun.getUTCDate() !== hedefGun)
        gun.setUTCDate(0);
    return gun;
}
/**
 * Yetkinliğin bitiş tarihi ÜÇ SÜRE ETİKETİNDEN türer (Kapsam §16.10/5):
 *   kural   → eğitim tarihi + periyot[tehlike sınıfı]
 *   belge   → kayıtta girilen tarih (sistem hesaplamaz)
 *   suresiz → null (bitiş yok)
 * Hesaplanamayan durumda `null` DÖNMEZ, HATA fırlatır: sessizce süresiz
 * yazmak, vadesi olan belgeyi sonsuza dek geçerli göstermek olurdu
 * (`deriveTehlikeSinifi` fail-loud deseni).
 */
function deriveYetkinlikBitis(girdi) {
    if (girdi.sureSinifi === 'suresiz')
        return null;
    if (girdi.sureSinifi === 'belge') {
        if (!girdi.belgeBitis) {
            throw new Error("'belge' süre sınıflı yetkinlikte bitiş tarihi kayıttan girilmelidir " +
                '(sistem hesaplamaz — tarih belgenin üstündedir)');
        }
        return girdi.belgeBitis;
    }
    // ✏️ 18.08.2026 (§16.10/15-B): PERİYOT YOKSA null döner — yetkinlik
    // süresiz geçerli sayılır ve uyarı `sureSinifiUyarilari`ndan düşer.
    // (Eski hâl: fail-loud hata. Yön değişti, ses kısılmadı.)
    if (!girdi.gecerlilikAy)
        return null;
    // Tehlike sınıfı okunamıyorsa HÂLÂ FAIL-LOUD: periyot VAR ama uygulanacağı
    // eksen bilinmiyor demektir — sessizce süresiz yazmak vadeli belgeyi
    // sonsuza dek geçerli göstermek olurdu.
    if (!girdi.tehlikeSinifi) {
        throw new Error("'kural' süre sınıflı yetkinlikte periyot uygulanamadı: kişinin şirket " +
            'tehlike sınıfı okunamadı (bitiş eğitim tarihi + periyottan hesaplanır)');
    }
    return ayEkle(girdi.egitimTarihi, girdi.gecerlilikAy[tehlikeSinifiAnahtari(girdi.tehlikeSinifi)]);
}
/**
 * SINAV SONUCU ÖNERİSİ (✏️ T3 revizyonu — 18.08.2026). Baraj VARDIR ama
 * **sonucu OTOMATİK YAZMAZ:** puan girilince sistem sonuç işaretini ÖNERİR,
 * uzman onaylar ya da değiştirir. Baraj tanımsızsa öneri de yoktur.
 */
function sinavSonucOnerisi(sonTestSkoru, baraj) {
    if (sonTestSkoru == null || baraj === null)
        return null;
    return sonTestSkoru >= baraj ? 'basarili' : 'basarisiz';
}
/**
 * "Eğitim baştan alınmalı" TÜRETİLMİŞ UYARISI (18.08.2026 mevzuat eki):
 * tavana ulaşmış deneme ∧ hâlâ başarısız. **ENGEL DEĞİL, GÖRÜNÜRLÜK** —
 * yeni eğitim kaydı açılınca sayaç sıfırdan başlar (yeni satır).
 */
function egitimBastanAlinmaliMi(sonuc, sinavDeneme) {
    return sonuc === 'basarisiz' && sinavDeneme >= exports.SINAV_DENEME_MAX;
}
/**
 * KİŞİ × SAAT — TÜRETİLİR, SAKLANMAZ (§16.8.1 oran deseninin eğitim ikizi:
 * saklanan yalnız pay ve payda; sonuç rapor anında hesaplanır). Birim DERS
 * SAATİdir — saate çevrilmez.
 */
function egitimKisiSaat(katilimciSayisi, sureDersSaati) {
    return katilimciSayisi * sureDersSaati;
}
function dersSaatiUyarilari(girdi) {
    if (!girdi.dersSaati || !girdi.tehlikeSinifi)
        return [];
    const anahtar = tehlikeSinifiAnahtari(girdi.tehlikeSinifi);
    const asgari = girdi.ilkVerilis ? girdi.dersSaati.ilk[anahtar] : girdi.dersSaati.tekrar[anahtar];
    const uyarilar = [];
    if (girdi.sureDersSaati < asgari) {
        uyarilar.push(`Süre asgarinin altında: ${girdi.sureDersSaati} ders saati girildi, ` +
            `bu tehlike sınıfında ${girdi.ilkVerilis ? 'ilk veriliş' : 'tekrar'} için ` +
            `en az ${asgari} ders saati beklenir`);
    }
    // Grup düzeyinde asgari süre (md. 13/3) — grup ETİKETİ kütüphanede olduğu
    // için kural yazılabiliyor (kalemleri müşteriye ait; ✏️ EK.2 revizyonu).
    if (!girdi.dorduncuGrupIsaretli) {
        uyarilar.push(`Ek-1 dördüncü grup (işyerine özel riskler) konusu işaretlenmemiş — ` +
            `bu tehlike sınıfında en az ${girdi.dersSaati.dorduncu_grup[anahtar]} ders saati ` +
            'bu gruba ayrılmalıdır');
    }
    return uyarilar;
}
// ── T9 — tenant yetki listesi anahtarı (U6 ilkesinin eğitim kolu) ────────────
/**
 * `egitim_kaydi` — eğitim kaydı açma/düzenleme/katılımcı işaretleme/ek
 * yönetimi/QR üretme yetkisini taşıyan TEK anahtar (Kapsam §16.10/13 + §20.5).
 * Yerleşim `tenant_setting`; yeni tablo YOK (olay U6 anahtarlarının kardeşi).
 */
exports.EGITIM_YETKI_ANAHTARI = 'egitim_kaydi';
/**
 * ~~VARSAYILAN = olay modülünün U7 varsayılanıyla AYNI (T9)~~ ✏️ **REVİZE
 * 04.09.2026 (5½ / C1 — ürün sahibi kararı A; Kapsam §16.10/13 revizyon
 * izi + §16.10/25):** *uzman/teknisyen + YÖNETİCİ ÜÇLÜSÜ* — holding
 * yöneticisi de girdi; liste olayınkinden **ayrıştı** (kopya değil, kendi
 * satırı). Gezinti bulgusu: holding yöneticisi eğitim kaydı **açamıyordu**
 * ve bunu bir arıza sanıyordu. **Boş liste = varsayılan geçerli** (c1) —
 * kayıt kaybı 422'den pahalıdır; yapılandırılmış tenant listesi etkilenmez.
 * İK'lı senaryo listeye ŞAPKA EKLENEREK çözülür; **İK şapkası AÇILMAZ**
 * (29.07.2026 kilidi).
 */
exports.EGITIM_YETKI_VARSAYILAN = [
    ...incident_1.OLAY_YETKI_VARSAYILAN,
    'holding_admin',
];
/**
 * TABAN KİLİTLER — hiçbir tenant yapılandırması aşamaz (U6 kuralının eğitim
 * karşılığı): `viewer` hiçbir yazma listesine giremez; `contractor_rep`
 * eğitim kaydı listesine giremez (yalnız `calisma_saati_giris`e eklenebilir
 * — eğitim kaydını İÇ KULLANICI açar, T1). Dönen değer ihlal mesajıdır;
 * null = liste geçerli.
 */
function egitimYetkiListesiIhlali(liste) {
    for (const sapka of liste) {
        if (!shared_types_1.ROLE_TYPES.includes(sapka)) {
            return `Tanınmayan şapka: ${sapka}`;
        }
        if (sapka === 'viewer') {
            return 'İzleyici hiçbir yazma listesine eklenemez (salt-okunur genel kural)';
        }
        if (sapka === 'contractor_rep') {
            return ('Yüklenici temsilcisi eğitim kaydı listesine eklenemez — eğitim kaydını ' +
                'İÇ KULLANICI açar (T1); temsilci yalnız çalışma saati girişine eklenebilir');
        }
    }
    return null;
}
// ── API sözleşmeleri (F3B·S7 uçları — incident.ts deseni) ────────────────────
/** Katılımcı girdisi — kişi + TARAF çifti (T2). Sonuç varsayılanı `basarili`
 *  (T3: uzman yalnız istisnayı işaretler). */
exports.trainingKatilimciInputSchema = zod_1.z.object({
    personId: zod_1.z.uuid(),
    taraf: exports.egitimTarafiSchema,
    sonuc: exports.egitimSonucuSchema.optional(),
    onTestSkoru: zod_1.z.number().min(0).max(100).nullish(),
    sonTestSkoru: zod_1.z.number().min(0).max(100).nullish(),
});
/** Kayıt açma (T1) — künye + konu işaretleri + katılımcılar TEK istekte.
 *  `sureDersSaati` BİRİM DERS SAATİDİR (saate çevrilmez — §16.10/7). */
exports.trainingCreateSchema = zod_1.z.object({
    workplaceId: zod_1.z.uuid(),
    locationNodeId: zod_1.z.uuid().nullish(),
    egitimTuruRefId: zod_1.z.uuid(),
    tarih: zod_1.z.iso.date(),
    sureDersSaati: zod_1.z.number().positive().max(999),
    yontem: exports.egitimYontemiSchema,
    egiticiPersonId: zod_1.z.uuid().nullish(),
    egiticiKurum: zod_1.z.string().max(200).nullish(),
    egiticiAd: zod_1.z.string().max(200).nullish(),
    /**
     * İ4 (tur 5) — DIŞ eğiticinin TC kimlik no'su, İSTEĞE BAĞLI (ürün sahibi
     * kararı A). Yalnız dış eğiticide anlamlıdır (iç eğiticinin kimliği kişi
     * kaydındadır); algoritma denetimi ve maske SUNUCUDADIR. Ekranda
     * *"İBYS'ye bildirilemez"* uyarısı YAZILMAZ — bugün gönderim yok.
     */
    egiticiKimlikNo: zod_1.z.string().trim().max(11).nullish(),
    /** İ3 (tur 5) — sorumlu İSG profesyoneli; boşsa sunucu kaydı açanın kişisini yazar. */
    sorumluPersonId: zod_1.z.uuid().nullish(),
    /** İ1 (tur 5) — İBYS referans listeleri (`egitim_yeri` · `sertifika_tipi`); boş dağıtılır. */
    egitimYeriRefId: zod_1.z.uuid().nullish(),
    sertifikaTipiRefId: zod_1.z.uuid().nullish(),
    notlar: zod_1.z.string().max(4000).nullish(),
    konuRefIds: zod_1.z.array(zod_1.z.uuid()).max(60).optional(),
    katilimcilar: zod_1.z.array(exports.trainingKatilimciInputSchema).max(500).optional(),
});
/** Künye düzeltme — tür/işyeri DEĞİŞMEZ (kayıt kimliği ve bahçe ekseni). */
exports.trainingUpdateSchema = zod_1.z.object({
    tarih: zod_1.z.iso.date().optional(),
    sureDersSaati: zod_1.z.number().positive().max(999).optional(),
    yontem: exports.egitimYontemiSchema.optional(),
    locationNodeId: zod_1.z.uuid().nullish(),
    egiticiPersonId: zod_1.z.uuid().nullish(),
    egiticiKurum: zod_1.z.string().max(200).nullish(),
    egiticiAd: zod_1.z.string().max(200).nullish(),
    egiticiKimlikNo: zod_1.z.string().trim().max(11).nullish(),
    sorumluPersonId: zod_1.z.uuid().nullish(),
    egitimYeriRefId: zod_1.z.uuid().nullish(),
    sertifikaTipiRefId: zod_1.z.uuid().nullish(),
    notlar: zod_1.z.string().max(4000).nullish(),
});
/** Katılımcı ekleme TOPLUDUR (salonda liste tek seferde işaretlenir). */
exports.trainingParticipantAddSchema = zod_1.z.object({
    katilimcilar: zod_1.z.array(exports.trainingKatilimciInputSchema).min(1).max(500),
});
/** Sonuç/puan işaretleme. `yeniDeneme` sayacı ARTIRIR (tavan 3 — DB CHECK). */
exports.trainingParticipantSonucSchema = zod_1.z.object({
    sonuc: exports.egitimSonucuSchema.optional(),
    onTestSkoru: zod_1.z.number().min(0).max(100).nullish(),
    sonTestSkoru: zod_1.z.number().min(0).max(100).nullish(),
    yeniDeneme: zod_1.z.boolean().optional(),
});
/** Temel İSG müfredat işaretleri — ÇOKLU; gönderilen liste kaydın TAM
 *  listesidir (eksikler düşer, yeniler eklenir). */
exports.trainingKonuSchema = zod_1.z.object({
    konuRefIds: zod_1.z.array(zod_1.z.uuid()).max(60),
});
/** Değerlendirme QR'ı üretme (§16.10/9-b) — gövde YOK; hedef URL'deki kayıt. */
exports.trainingQrSonucSchema = zod_1.z.object({
    token: zod_1.z.string().min(1),
    link: zod_1.z.url(),
    egitimTuruAd: zod_1.z.string(),
    tarih: zod_1.z.iso.date(),
    /** Katılımcı listesi BOŞKEN de QR alınır — sayı yalnız bilgidir. */
    katilimciSayisi: zod_1.z.number().int().nonnegative(),
});
/**
 * YETKİNLİK VADE DURUMU (F4·S5·B4 — kişi kartı rozetleri; Kapsam §20.3b P3).
 *
 * ⚠️ **EŞİK BU FONKSİYONA GÖMÜLMEZ:** `uyariEsigiGun` parametredir ve tek
 * kaynağı `@isg/db resolveUyariEsigi('egitim_yetkinlik_vadesi')`tir (F4·S1
 * "eşik tek okuyucudan" kuralı). Ekran 30 yazmaz; sunucu türetir, rozet
 * yalnız ANLAMA çevirir.
 *
 * `suresiz` (bitiş null) vade EKSENİNE HİÇ GİRMEZ (§19/11-7): belge var/yok
 * kontrolü sürer ama süre kontrolü yapılmaz — "uzak tarihle taklit etme"
 * yasağının okuma tarafı.
 */
exports.YETKINLIK_VADE_DURUMLARI = [
    'suresiz',
    'gecerli',
    'yaklasiyor',
    'doldu',
    /**
     * ✏️ K9 (tur 5): BAŞLANGICI GELECEKTE olan belge — *"henüz geçerli değil"*.
     * Ne `gecerli`dir (bugün taşınmaz) ne `doldu` (henüz başlamadı). Eksik
     * damgasını SÖNDÜRMEZ ve PTW kapısını AÇMAZ; üç okuyucu (kişi kartı rozeti ·
     * uygunluk paneli · PTW şart filtresi) bu TEK yüklemden okur.
     */
    'henuz_degil',
];
exports.yetkinlikVadeDurumuSchema = zod_1.z.enum(exports.YETKINLIK_VADE_DURUMLARI);
/**
 * ⚠️ ÜÇ OKUYUCUNUN TEK YÜKLEMİ (K9): kişi kartı rozeti (`person.controller`),
 * uygunluk paneli / *"eksik"* damgası (`uygunlukSatirDurumu`) ve PTW şart
 * filtresi (`ptw-eligibility`). Tarih aritmetiği yalnız burada; kopyası
 * yazılmaz — tur 4½'te `vadeDurumuHam` adıyla bir kopya vardı ve başlangıç
 * ekseni ona hiç işlenmemişti; kopya bu turda SÖKÜLDÜ.
 *
 * ISO tarih (YYYY-MM-DD) sözlük sırası = kronolojik sıra; iki taraf da gün
 * hassasiyetinde karşılaştırılır (saat/dilim oyunu yok).
 */
function yetkinlikVadeDurumu(gecerlilikBaslangic, gecerlilikBitis, bugun, uyariEsigiGun) {
    // Başlangıç gelecekteyse belge BUGÜN geçersizdir — bitişine bakılmaz.
    if (gecerlilikBaslangic > bugun)
        return 'henuz_degil';
    if (gecerlilikBitis === null)
        return 'suresiz';
    if (gecerlilikBitis < bugun)
        return 'doldu';
    const esik = new Date(`${bugun}T00:00:00Z`);
    esik.setUTCDate(esik.getUTCDate() + uyariEsigiGun);
    return gecerlilikBitis <= esik.toISOString().slice(0, 10) ? 'yaklasiyor' : 'gecerli';
}
/** Vade durumu bugün belgeyi TAŞITIR mı — PTW ve panelin ortak sorusu. */
function yetkinlikBugunGecerliMi(durum) {
    return durum === 'suresiz' || durum === 'gecerli' || durum === 'yaklasiyor';
}
/**
 * K8 — `on_kosul` (temel İSG) kalemi YENİ İŞE GİRİŞTE TEKRAR ister (§2.11):
 * belgenin başlangıcı güncel istihdamın başlangıcından ÖNCEYSE bu istihdam
 * için sayılmaz. PTW motoru ve uygunluk paneli **AYNI** yüklemi okur — aynı
 * soruya iki cevap biter (tur 5 dersi).
 */
function onKosulIstihdamSonrasiMi(yetkinlikBaslangicIso, istihdamBaslangicIso) {
    return yetkinlikBaslangicIso >= istihdamBaslangicIso;
}
exports.trainingSummarySchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    egitimTuruRefId: zod_1.z.uuid(),
    egitimTuruAd: zod_1.z.string(),
    grup: zod_1.z.string().nullable(),
    workplaceId: zod_1.z.uuid(),
    workplaceAd: zod_1.z.string(),
    locationAd: zod_1.z.string().nullable(),
    tarih: zod_1.z.iso.date(),
    /** SÖ-1 (02.11.2026): devir kaydında NULL olabilir — ekran "—" basar, hesaplamaz. */
    sureDersSaati: zod_1.z.number().nullable(),
    yontem: exports.egitimYontemiSchema.nullable(),
    /**
     * SİSTEM ÖNCESİ KAYIT (SÖ-1 — `equipment_inspection.devir_mi` emsali): toplu
     * devir yüklemesinden doğan kayıt. Liste ve detayda rozet; işaret kalıcı.
     */
    devirMi: zod_1.z.boolean(),
    egiticiAd: zod_1.z.string().nullable(),
    egiticiKurum: zod_1.z.string().nullable(),
    /** İ3 — sorumlu İSG profesyoneli (kişi referansı; ad SUNUCUDA çözülür). */
    sorumluPersonId: zod_1.z.uuid().nullable(),
    sorumluAd: zod_1.z.string().nullable(),
    katilimciSayisi: zod_1.z.number().int().nonnegative(),
    basariliSayisi: zod_1.z.number().int().nonnegative(),
    /** TÜRETİLMİŞ oran (T4) — kolon değil: yanıt / katılımcı. */
    degerlendirmeYanitSayisi: zod_1.z.number().int().nonnegative(),
    /** Ders saati asgarileri (EK.1) — UYARI, ENGEL DEĞİL. */
    sureUyarisiVar: zod_1.z.boolean(),
    /**
     * KİŞİ süzgeçli listede (kişi kartı — F4·S5·B4): bu eğitimden DOĞAN
     * yetkinliğin vadesi. Eğitim yetkinlik üretmediyse / kişi süzgeci yoksa
     * null — modül listesi bu alanları taşımaz, satır rozetsiz kalır.
     */
    vadeBitis: zod_1.z.iso.date().nullable(),
    vadeDurumu: exports.yetkinlikVadeDurumuSchema.nullable(),
    createdAt: zod_1.z.iso.datetime(),
});
exports.trainingDetailSchema = exports.trainingSummarySchema.extend({
    locationNodeId: zod_1.z.uuid().nullable(),
    egiticiPersonId: zod_1.z.uuid().nullable(),
    /** İ4 — dış eğitici TC'si MASKELİ iner (madde 37 kuralı eğiticiye de uygulanır). */
    egiticiKimlikNoMaskeli: zod_1.z.string().nullable(),
    egitimYeriRefId: zod_1.z.uuid().nullable(),
    egitimYeriAd: zod_1.z.string().nullable(),
    sertifikaTipiRefId: zod_1.z.uuid().nullable(),
    sertifikaTipiAd: zod_1.z.string().nullable(),
    notlar: zod_1.z.string().nullable(),
    kisiSaat: zod_1.z.number(),
    uyarilar: zod_1.z.array(zod_1.z.string()),
    katilimcilar: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        personId: zod_1.z.uuid(),
        adSoyad: zod_1.z.string(),
        taraf: exports.egitimTarafiSchema,
        sonuc: exports.egitimSonucuSchema,
        onTestSkoru: zod_1.z.number().nullable(),
        sonTestSkoru: zod_1.z.number().nullable(),
        sinavDeneme: zod_1.z.number().int(),
        /** Sistem ÖNERİSİ — sonucu YAZMAZ (✏️ T3'ün özü). */
        onerilenSonuc: exports.egitimSonucuSchema.nullable(),
        /** Üçüncü denemede de başarısız (türetilmiş uyarı — engel değil). */
        bastanAlinmali: zod_1.z.boolean(),
        /** Bu satırdan yetkinlik doğdu mu (tek yazıcının görünür izi). */
        yetkinlikDogdu: zod_1.z.boolean(),
    })),
    konular: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), konuRefId: zod_1.z.uuid(), ad: zod_1.z.string() })),
    ekler: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        dosyaAdi: zod_1.z.string(),
        mimeType: zod_1.z.string(),
        boyutBytes: zod_1.z.number().int(),
        createdAt: zod_1.z.iso.datetime(),
    })),
    /** Tür kalemi yetkinlik üretiyor mu (T5) — ekran "bu eğitim belge doğurur"
     *  bilgisini SUNUCUDAN okur, kütüphane kuralını tanımaz. */
    yetkinlikUretir: zod_1.z.boolean(),
    yetkiler: zod_1.z.object({
        duzenleyebilir: zod_1.z.boolean(),
        qrUretebilir: zod_1.z.boolean(),
        /** P13 — eğitim yazma kapısı (tenant `egitim_kaydi` listesi → bahçe) + sebep. */
        yazmaKapisi: kapi_durumu_1.kapiDurumuSchema,
    }),
});
exports.trainingOptionsSchema = zod_1.z.object({
    workplaces: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string(), companyAd: zod_1.z.string() })),
    /** Şemsiye kalem (grup başlığı) LİSTEYE GİRMEZ — kayıt alamaz (C.1). */
    egitimTurleri: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        ad: zod_1.z.string(),
        grup: zod_1.z.string().nullable(),
        /** Temel İSG gibi müfredat konusu işaretlenen tür mü (EK.1 kuralı). */
        konuIster: zod_1.z.boolean(),
        yetkinlikUretir: zod_1.z.boolean(),
        sureSinifi: exports.sureSinifiSchema.nullable(),
    })),
    egitimKonulari: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string(), grup: zod_1.z.string().nullable() })),
    /** İ1 — İBYS referans listeleri; kütüphane BOŞ dağıtır, müşteri/doğrulama doldurur. */
    egitimYerleri: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string() })),
    sertifikaTipleri: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string() })),
    personeller: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), adSoyad: zod_1.z.string() })),
    /** Katılımcı TARAFI otomatik seçilsin diye: yüklenici istihdamlı kişiler. */
    yukleniciPersonIds: zod_1.z.array(zod_1.z.uuid()),
    kayitAcabilir: zod_1.z.boolean(),
});
// ── Kapı 2'nin ÜÇÜNCÜ uygulaması — public değerlendirme (T4) ─────────────────
/**
 * Public yüzeyin DAR künyesi (D2): eğitim + tarih + eğitici. **Katılımcı
 * listesi SIZDIRILMAZ** — QR eğitimi tanır, katılımcıyı DEĞİL (§16.10/9-a).
 */
exports.publicDegerlendirmeOptionsSchema = zod_1.z.object({
    egitimTuruAd: zod_1.z.string(),
    tarih: zod_1.z.iso.date(),
    egiticiAd: zod_1.z.string().nullable(),
    egiticiKurum: zod_1.z.string().nullable(),
    /** Şablonun YAYINLI sürümünün şeması (kayıt kendi sürümüyle okunur). */
    sema: zod_1.z.unknown(),
});
exports.publicDegerlendirmeCreateSchema = zod_1.z.object({
    token: zod_1.z.string().min(1),
    cevaplar: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
});
exports.publicDegerlendirmeSonucSchema = zod_1.z.object({
    /** Yanıt kaydedildi — kime ait olduğu BİLİNMEZ (anonim; R5). */
    kaydedildi: zod_1.z.literal(true),
});
exports.BOS_EGITIM_SUZGECI = {
    workplaceId: null,
    egitimTuruRefId: null,
    personId: null,
    baslangic: null,
    bitis: null,
    sureUyarisi: false,
    sayfa: 1,
};
exports.EGITIM_SAYFA_BOYUTU = 25;
/**
 * SÜZGEÇ DİZGİSİ TEK FONKSİYONDAN (ekipman `ekipmanSuzgecSorgusu` deseni):
 * ekranın listesi ve çıktı ucu aynı dizgiyi kurar — ikisi ayrı kurulsaydı
 * *"ekranda 12 vardı, dosyada 9 çıktı"* farkı doğardı.
 */
function egitimSuzgecSorgusu(suzgec, sayfalama) {
    const sorgu = new URLSearchParams();
    if (suzgec.workplaceId)
        sorgu.set('workplaceId', suzgec.workplaceId);
    if (suzgec.egitimTuruRefId)
        sorgu.set('egitimTuruRefId', suzgec.egitimTuruRefId);
    if (suzgec.personId)
        sorgu.set('personId', suzgec.personId);
    if (suzgec.baslangic)
        sorgu.set('baslangic', suzgec.baslangic);
    if (suzgec.bitis)
        sorgu.set('bitis', suzgec.bitis);
    if (suzgec.sureUyarisi)
        sorgu.set('sureUyarisi', 'true');
    if (sayfalama)
        sorgu.set('sayfa', String(suzgec.sayfa));
    const dizge = sorgu.toString();
    return dizge === '' ? '' : `?${dizge}`;
}
function etkinEgitimSuzgeciSayisi(suzgec) {
    return [
        suzgec.workplaceId,
        suzgec.egitimTuruRefId,
        suzgec.baslangic,
        suzgec.bitis,
        suzgec.sureUyarisi ? 'x' : null,
    ].filter((v) => v !== null).length;
}
exports.trainingListSchema = zod_1.z.object({
    satirlar: zod_1.z.array(exports.trainingSummarySchema),
    toplam: zod_1.z.number().int().nonnegative(),
    sayfa: zod_1.z.number().int().positive(),
    sayfaBoyutu: zod_1.z.number().int().positive(),
});
// ── Y4 (tur 5) — TOPLU AKTARMA RAPORU (içe aktarma motorunun 6. müşterisi) ──
/**
 * SATIR = KATILIMCI; satırlar oturum anahtarıyla gruplanır. Rapor satır
 * düzeyindedir (kısmi başarı): bir katılımcı satırı düşerse oturumun diğer
 * satırları girer; oturum künyesi düşerse o anahtarın TÜM satırları düşer.
 */
exports.EGITIM_ICE_AKTARMA_SONUCLARI = ['eklendi', 'hata'];
exports.egitimIceAktarmaSonucSchema = zod_1.z.enum(exports.EGITIM_ICE_AKTARMA_SONUCLARI);
exports.EGITIM_ICE_AKTARMA_SONUC_ETIKETI = {
    eklendi: 'Eklendi',
    hata: 'İşlenemedi',
};
/**
 * SİSTEM ÖNCESİ EĞİTİM YÜKLEMESİ — KİP (SÖ-1, 02.11.2026). Tek uç
 * (`POST trainings/import?kip=`), iki şablon; parse sonrası gövde ortak ve
 * `createTrainingSession` tek kapı. `standart` = tur 5'in oturum anahtarlı
 * şablonu (İBYS disiplini aynen); `sistem_oncesi` = başlıktan tanınan gevşek
 * şablon → `devir_mi = true` kayıt.
 */
exports.EGITIM_ICE_AKTARMA_KIPLERI = ['standart', 'sistem_oncesi'];
exports.egitimIceAktarmaKipiSchema = zod_1.z.enum(exports.EGITIM_ICE_AKTARMA_KIPLERI);
/** Sorgu dizgisinden kip: boş/eksik → `standart`; tanınmayan değer → null (uç 400 çevirir — sessizce standarda DÜŞMEZ). */
function egitimIceAktarmaKipiCoz(ham) {
    if (ham === undefined || ham === null || ham === '')
        return 'standart';
    const sonuc = exports.egitimIceAktarmaKipiSchema.safeParse(ham);
    return sonuc.success ? sonuc.data : null;
}
/**
 * Konu eşleme adımının girdisi (ikinci istek): Excel'deki benzersiz konu metni →
 * eğitim türü. `egitimTuruId: null` → **Diğer** türü (orijinal metin notlara).
 * Metin anahtarı sunucuda normalize edilir (`konuAnahtari`) — ekran olduğu gibi gönderir.
 */
exports.trainingDevirKonuEslemesiSchema = zod_1.z.object({
    konuEslemesi: zod_1.z.array(zod_1.z.object({ metin: zod_1.z.string().min(1), egitimTuruId: zod_1.z.uuid().nullable() })),
});
/**
 * ÖNİZLEME (yazmaz — `POST trainings/import/preview`; `import/persons/preview`
 * emsali). Dosyadaki benzersiz konular + tam ad eşleşmesiyle önerilen tür +
 * üç sayı. Kayıt AÇMAZ (kanarya e2e).
 */
exports.trainingImportPreviewSchema = zod_1.z.object({
    satirSayisi: zod_1.z.number().int().min(0),
    konular: zod_1.z.array(zod_1.z.object({
        /** Küçük harfe indirilip kırpılmış metin — ekran bunu geri gönderir. */
        metin: zod_1.z.string(),
        satirSayisi: zod_1.z.number().int().min(0),
        onerilenTurId: zod_1.z.uuid().nullable(),
        onerilenTurAd: zod_1.z.string().nullable(),
    })),
    eslesmeyenKisi: zod_1.z.number().int().min(0),
    hataliTarih: zod_1.z.number().int().min(0),
    /** Yok sayılan sütun başlıkları — yüklemeyi durdurmaz. */
    taninmayanBasliklar: zod_1.z.array(zod_1.z.string()),
});
/** Devir kipinin rapor özeti — standart kipte `null`. */
exports.trainingImportDevirOzetiSchema = zod_1.z.object({
    eslesmeyenKisi: zod_1.z.number().int().min(0),
    hataliTarih: zod_1.z.number().int().min(0),
    /** Eğitim tarihi hiçbir istihdam aralığına düşmedi — en yakın istihdamın işyerine yazıldı + uyarı. */
    istihdamDisi: zod_1.z.number().int().min(0),
    /** K-72 bilgisi: eğitim tarihi güncel istihdamın başlangıcından önce — uygunlukta sayılmaz (işe girişte tekrar). */
    istihdamOncesi: zod_1.z.number().int().min(0),
    taninmayanBasliklar: zod_1.z.array(zod_1.z.string()),
});
exports.trainingImportReportSchema = zod_1.z.object({
    toplam: zod_1.z.number().int().min(0),
    eklenen: zod_1.z.number().int().min(0),
    hatali: zod_1.z.number().int().min(0),
    /** Açılan oturum sayısı (bir anahtar = bir kayıt). */
    oturum: zod_1.z.number().int().min(0),
    /** SÖ-1: yalnız `kip=sistem_oncesi` raporu taşır; standart kipte null. */
    devir: exports.trainingImportDevirOzetiSchema.nullable(),
    satirlar: zod_1.z.array(zod_1.z.object({
        satir: zod_1.z.number().int().positive(),
        oturumAnahtari: zod_1.z.string(),
        sonuc: exports.egitimIceAktarmaSonucSchema,
        /** Eklenen satırda katılımcının adı; hatalı satırda null. */
        ad: zod_1.z.string().nullable(),
        /** Açılan eğitim kaydının kimliği (ekran bağlantı verir). */
        trainingSessionId: zod_1.z.uuid().nullable(),
        mesaj: zod_1.z.string().nullable(),
        uyarilar: zod_1.z.array(zod_1.z.string()),
    })),
});
//# sourceMappingURL=egitim.js.map